export default __webpack_public_path__ + "static/Screenshot2-6e1763070c9248ed35ea91f0d2e1d495.jpg";